import { USER_LOGIN_ABORT, USER_LOGIN_SUCCESS, USER_PRELOGIN_SUCCESS } from '../../actions/authentication';

const preAuthenticationToken = (state = null, action = undefined) => {
    switch (action.type) {
        case USER_PRELOGIN_SUCCESS:
            return action.payload;
        case USER_LOGIN_SUCCESS:
            return null;
        case USER_LOGIN_ABORT:
            return null;
        default:
            return state;
    }
};

export default preAuthenticationToken;
